import { HAND_AUTHORED } from './corpus.js';
import { FULL_PUZZLES } from './full.js';
import { GENERATED } from './generated.js';
import { GENERATED_MIDI } from './generated-midi.js';
export { HAND_AUTHORED } from './corpus.js';
export { FULL_PUZZLES } from './full.js';
export { GENERATED } from './generated.js';
export { GENERATED_MIDI } from './generated-midi.js';
export const ALL_PUZZLES = [
    ...HAND_AUTHORED,
    ...GENERATED,
    ...GENERATED_MIDI,
    ...FULL_PUZZLES,
];
export function puzzlesOfSize(size) {
    return ALL_PUZZLES.filter((p) => p.size === size);
}
/** Look up a shipped puzzle by id, or null. */
export function puzzleById(id) {
    return ALL_PUZZLES.find((p) => p.id === id) ?? null;
}
/**
 * Live counts per size. Inventory claims should be generated from this rather
 * than transcribed — a number in a slide deck goes stale the day the corpus
 * grows, and the counting policy requires the census to derive from code.
 */
export function puzzleCountsBySize() {
    const counts = { mini: 0, midi: 0, full: 0 };
    for (const p of ALL_PUZZLES)
        counts[p.size] += 1;
    return { ...counts, total: ALL_PUZZLES.length };
}
//# sourceMappingURL=index.js.map